var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-footer"},[_vm._v(" Copyright © "+_vm._s((new Date).getFullYear())+" 澄合矿业有限公司物资供销分公司  |  联系地址：陕西省渭南市澄城县城关镇南新街65号  |  邮政编码：715200  |  "),_c('a',{attrs:{"href":"https://beian.mps.gov.cn/","target":"_blank"}},[_vm._v("陕ICP备2025059416号-1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }